<!-- SDG picker — "Need some inspiration?" -->
<div class="rounded-lg border border-greyscale-200 bg-white p-4">
  <div class="mb-4">
    <h2 class="text-heading-4 font-semibold text-primary-900">
      {{ "objectives.needInspiration" | transloco }}
    </h2>
    <p class="mt-1 text-paragraph-s-reg text-greyscale-600">
      {{ "objectives.sdgDescription" | transloco }}
    </p>
  </div>

  <div class="mb-4 flex items-center justify-between">
    <span class="text-paragraph-s-reg font-medium text-greyscale-600">
      {{ "objectives.sdgSelected" | transloco: { count: selectionCount() } }}
    </span>
    <span class="flex items-center gap-1.5 text-paragraph-xs-reg text-primary-600">
      <lucide-angular [img]="Globe" class="h-4 w-4" />
      {{ "objectives.sdgSdg13Required" | transloco }}
    </span>
  </div>

  <div class="grid grid-cols-3 gap-3 sm:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
    @for (sdg of SDG_DATA; track sdg.id) {
      <button
        type="button"
        (click)="toggleSdg(sdg.id)"
        class="group relative overflow-hidden rounded-md transition-all duration-150 focus:outline-none"
        [class.ring-4]="isSelected(sdg.id)"
        [class.ring-offset-1]="isSelected(sdg.id)"
        [class.ring-primary-400]="isSelected(sdg.id) && !isLocked(sdg.id)"
        [class.ring-primary-600]="isLocked(sdg.id)"
        [class.cursor-default]="isLocked(sdg.id)"
        [class.opacity-40]="!isSelected(sdg.id)"
        [class.hover:opacity-100]="!isLocked(sdg.id) && !isSelected(sdg.id)"
      >
        <img
          [src]="activeLang() === 'fr' ? sdg.iconPathFr : sdg.iconPath"
          [alt]="'SDG ' + sdg.id + ' - ' + sdg.title"
          class="w-full"
          loading="lazy"
        />

        @if (isSelected(sdg.id)) {
          <span
            class="absolute right-1.5 top-1.5 flex h-5 w-5 items-center justify-center rounded-full shadow"
            [class.bg-primary-400]="!isLocked(sdg.id)"
            [class.bg-primary-600]="isLocked(sdg.id)"
          >
            <lucide-angular [img]="Check" class="h-3 w-3 text-white" />
          </span>
        }
      </button>
    }
  </div>
</div>

<!-- Selected SDG tips (read-only) -->
@if (selectedSdgData().length > 0) {
  <div class="mt-4 rounded-lg border border-greyscale-200 bg-white p-4">
    <h3 class="mb-3 text-paragraph-s-reg font-semibold text-primary-900">
      {{ "objectives.sdgYourGoals" | transloco }}
    </h3>
    <div
      class="grid grid-cols-1 gap-4"
      [class.sm:grid-cols-2]="selectedSdgData().length > 1"
      [class.lg:grid-cols-3]="selectedSdgData().length > 2"
    >
      @for (sdg of selectedSdgData(); track sdg.id) {
        <div class="rounded-lg border border-primary-200 bg-primary-50 p-4">
          <div class="mb-3 flex items-center gap-3">
            <img
              [src]="activeLang() === 'fr' ? sdg.iconPathFr : sdg.iconPath"
              [alt]="'SDG ' + sdg.id"
              class="h-12 w-12 shrink-0 rounded"
              loading="lazy"
            />
            <h4 class="text-paragraph-reg font-bold text-primary-900">
              {{ sdg.title }}
            </h4>
          </div>
          <ul class="space-y-2">
            @for (tip of getSdgTips(sdg.id); track tip) {
              <li
                class="flex items-start gap-2 text-paragraph-xs-reg leading-snug text-greyscale-600"
              >
                <span class="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-greyscale-400"></span>
                <span>{{ tip }}</span>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
}
